import { Button, IconButton, Typography } from "@suraasa/placebo-ui"
import { useQuery } from "@tanstack/react-query"
import api from "api"
import { queries } from "api/queries"
import { CheckCircle, DownloadSquare } from "iconoir-react"
import { downloadFile } from "utils/helpers"
import { trackingService } from "utils/tracking"
import { TrackingEvents } from "utils/tracking/events"

type AttendedProps = {
  id: string | number
}

const Attended = ({ id }: AttendedProps) => {
  const itemType = "masterclass"

  const { data } = useQuery({
    queryKey: queries.credentials.getUserCredentials(itemType, id).queryKey,
    queryFn: () =>
      api.credentials.getUserCredentials({
        urlParams: { itemType: itemType, itemId: id },
      }),
  })

  const pdfFile = data?.pdfFile

  return (
    <div className="mt-2 flex items-center justify-between gap-y-1 rounded-lg bg-success-500 px-2 py-1.5">
      <Typography
        className="flex items-center gap-0.5 text-common-white-200"
        variant="strong"
      >
        <CheckCircle className="!size-2.5 shrink-0" /> <span>Attended</span>
      </Typography>
      {pdfFile && (
        <>
          <IconButton
            className="text-white hover:bg-white hover:text-success-500 hover:opacity-90 sm:hidden"
            onClick={() => {
              trackingService.trackEvent(
                TrackingEvents.masterclassCertificateDownloaded,
                {
                  masterclass_id: id,
                },
                { services: ["PostHog"] }
              )
              downloadFile(pdfFile, "masterclass-certificate")
            }}
          >
            <DownloadSquare />
          </IconButton>
          <Button
            className="hidden text-white hover:bg-white hover:text-success-500 hover:opacity-90 sm:inline-flex"
            startAdornment={<DownloadSquare />}
            variant="text"
            onClick={() => {
              trackingService.trackEvent(
                TrackingEvents.masterclassCertificateDownloaded,
                {
                  masterclass_id: id,
                },
                { services: ["PostHog"] }
              )
              downloadFile(pdfFile, "masterclass-certificate")
            }}
          >
            View Certificate
          </Button>
        </>
      )}
    </div>
  )
}

export default Attended
